import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/cecitemunit/cecItemUnit/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/cecitemunit/cecItemUnit/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/cecitemunit/cecItemUnit/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/cecitemunit/cecItemUnit/list',
      method: 'get',
      params: params
    })
  },

  noPermissionList: function (params) {
    return request({
      url: '/cecitemunit/cecItemUnit/noPermission/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/cecitemunit/cecItemUnit/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/cecitemunit/cecItemUnit/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/cecitemunit/cecItemUnit/import',
      method: 'post',
      data: data
    })
  }
}
